<template>
  <g fill-rule="evenodd">
    <path
      d="M13.78 14.83c0 .3-.25.56-.56.56H6.8a.56.56 0 01-.56-.56V3.77c0-.3.25-.55.56-.55h6.42c.3 0 .56.25.56.55v11.06zM10 17.63a.68.68 0 110-1.37.68.68 0 010 1.36zm0-15.65c.21 0 .38.16.38.38 0 .21-.17.37-.38.37a.37.37 0 01-.38-.37c0-.22.16-.38.38-.38zm3.6-.48H6.4c-.77 0-1.4.63-1.4 1.4v14.2c0 .77.63 1.4 1.4 1.4h7.2c.77 0 1.4-.63 1.4-1.4V2.9c.02-.77-.61-1.4-1.38-1.4z"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "PhoneIcon",
});
</script>
